// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"305":"fa3dcf8d","508":"fa3dcf8d","672":"fa3dcf8d","985":"fa3dcf8d"}[chunkId] + ".css";
};